import genererGuid from '@/services/general/genererGuid';

export default function genererPageParution(ordre) {
  return {
    id: genererGuid(),
    ordre: ordre,
    nom: null,
    largeurUtile: 0,
    hauteurUtile: 0,
    largeur: 0,
    hauteur: 0,
    margeGauche: 0,
    margeHaute: 0,
    surfaceId: null,
    emplacementId: null,
    couleurEncartId: null,
    isCreate: true,
    selected: false,
  };
}
